<template>
  <md-dialog
    :md-active.sync="show"
    @md-opened="openDialog"
    md-close-on-esc="false"
    class="warning-dialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog"
  >
    <div class="md-dialog-content md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h2><i class="fa fa-spinner"></i> {{ title || "Waiting For Server" }}</h2>

        <div class="md-subheading warning-text">
          {{
            message ||
            "We are waiting for server to restart. " +
              "This message will automatically be closed in the case that server restarts successfully. " +
              "It should not takes more than 30 seconds, otherwise you should close this dialog and troubleshoot the server."
          }}
        </div>
        <div dir="rtl">
          <md-button @click="closeDialog">{{ button || "Close" }}</md-button>
        </div>
      </div>
    </div>
  </md-dialog>
</template>

<script>
export default {
  name: "WaitingForServer",
  props: ["show", "message", "title", "button"],
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    doPing: async function () {
      const response = await this.$api.ping();
      if (response.status === 200) this.closeDialog();
      else setTimeout(this.doPing, 3000);
    },
    openDialog: function () {
      setTimeout(this.doPing, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.warning-text {
  text-align: justify !important;
}

.spinner {
  margin: auto 0;
  text-align: center;
  vertical-align: middle;
}
</style>
